import { useState, useRef, useCallback, useEffect } from "react";

const getRecognition = () => {
  const SR = window.SpeechRecognition || window.webkitSpeechRecognition;
  if (!SR) return null;
  const rec = new SR();
  rec.lang = "fr-FR";
  rec.continuous = true;
  rec.interimResults = true;
  return rec;
};

export const isDictationSupported = () =>
  !!(window.SpeechRecognition || window.webkitSpeechRecognition);

export function useDictation(onFinalText) {
  const [listening, setListening] = useState(false);
  const recRef = useRef(null);
  const baseRef = useRef("");
  const onFinalRef = useRef(onFinalText);
  onFinalRef.current = onFinalText;

  const stop = useCallback(() => {
    if (recRef.current) {
      recRef.current.stop();
    }
    setListening(false);
  }, []);

  const start = useCallback((currentValue) => {
    const rec = getRecognition();
    if (!rec) return false;
    recRef.current = rec;
    baseRef.current = currentValue ? currentValue.trim() + " " : "";

    rec.onresult = (event) => {
      let interim = "";
      let finalChunk = "";
      for (let i = event.resultIndex; i < event.results.length; i++) {
        const t = event.results[i][0].transcript;
        if (event.results[i].isFinal) finalChunk += t;
        else interim += t;
      }
      if (finalChunk) {
        baseRef.current = (baseRef.current + finalChunk).replace(/\s+/g, " ");
      }
      onFinalRef.current((baseRef.current + " " + interim).trim());
    };
    rec.onerror = () => setListening(false);
    rec.onend = () => setListening(false);

    rec.start();
    setListening(true);
    return true;
  }, []);

  useEffect(() => () => recRef.current && recRef.current.stop(), []);

  return { listening, start, stop };
}
